site.mMenu = {
	init: function() {
		var $mMenu = $('#mainmenu').clone().prop('id', 'mMenu').attr('role','navigation');
		$('#qn li:not(:last-child)').each(function() {
			$(this).clone().addClass('level1').appendTo($mMenu.find('.mmLevel1'));
		});
		$('body').append($mMenu);

		//var $mHeader = $('#header').clone().prop('id', 'mHeader').addClass('Fixed');
		//$('body').append($mHeader);

		$('#mMenu').mmenu({
			// options
			offCanvas: {
				position: "right"
			},
			extensions: ["theme-moya"],
			navbars: [{
				position: "top",
				content: $('li:last-child a', '#qn').clone().prop('id','mqn')
			}]
		},{
			// configuration
			classNames: {
				selected:"active",
				fixed: "header"
			}
		});
		
		$("#mainmenuToggle").click(function( ev ) {
			if ($("html").hasClass( "mm-opened" )) {
				$("#mMenu").data( "mmenu" ).close();
			}
		});

		/*var $mSearch = $('#searchForm').clone().prop('id','mSearchForm');
		$('.mm-panel:first-child .mm-navbar','#mMenu').append($mSearch);*/

		$('#mMenu .mm-next').append('<span class="sr-only">Next</span>');
		$('#mMenu .mm-btn.mm-prev').append('<span class="sr-only">Prev</span>');
		$('#mSearchForm label').remove();
	}
};

